module.exports = __webpack_public_path__ + "img/sample_Headshot-shadow-box.89f33f2a.png";